import React from "react";
import {Link} from "react-router-dom";
import {useCart} from "../contexts/CartContext";
import {XCircle, ShoppingCart, ArrowLeft} from "lucide-react";

const CheckoutCancel: React.FC = () => {
  const {state} = useCart();

  return (
    <div className="max-w-2xl mx-auto py-12 px-4">
      <div className="text-center mb-8">
        <XCircle className="mx-auto h-16 w-16 text-red-500 mb-4" />
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Payment Cancelled
        </h1>
        <p className="text-lg text-gray-600">
          Your payment was cancelled and no charges were made.
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          What happened?
        </h2>
        <div className="space-y-3 text-gray-600">
          <p>• Your payment was cancelled before completion</p>
          <p>• No money was charged to your account</p>
          <p>• Your order was not placed</p>
          <p>• Your cart items are still available</p>
        </div>
      </div>

      {state.items.length > 0 && (
        <div className="bg-blue-50 rounded-lg p-6 mb-8">
          <div className="flex items-center gap-3 mb-4">
            <ShoppingCart className="h-6 w-6 text-blue-600" />
            <h3 className="text-lg font-semibold text-blue-900">
              Your Cart is Still Here
            </h3>
          </div>
          <p className="text-blue-700 mb-4">
            Good news! Your cart items are still saved. You can continue
            shopping or try the checkout process again.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to="/shop"
              className="btn btn-primary flex items-center justify-center gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              Continue Shopping
            </Link>
            <Link
              to="/checkout"
              className="btn btn-secondary flex items-center justify-center gap-2"
            >
              Try Checkout Again
            </Link>
          </div>
        </div>
      )}

      <div className="bg-gray-50 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-3">Need Help?</h3>
        <div className="space-y-2 text-gray-600">
          <p>
            If you experienced any issues or have questions about your order,
            please don't hesitate to reach out:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-4">
            <li>Check our FAQ section for common questions</li>
            <li>Contact our support team for assistance</li>
            <li>Review your payment method and try again</li>
          </ul>
        </div>
        <div className="mt-4 flex flex-col sm:flex-row gap-3">
          <Link
            to="/"
            className="btn btn-secondary flex items-center justify-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Link>
          <Link
            to="/shop"
            className="btn btn-primary flex items-center justify-center gap-2"
          >
            Browse Books
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel;
